import { gettext } from '@eb/i18n';

export const MANAGE_TEXTS = {
    allDates: gettext('Manage all dates'),
    canceled: gettext('Canceled'),
    upcomingDate: gettext('Manage next upcoming date'),
};

// Currently only 'DRAFT' and 'LIVE' are in use for this page
export const STATUS_DISPLAY_MAP_UPPERCASE = {
    unsaved: gettext('UNSAVED'),
    draft: gettext('DRAFT'),
    canceled: gettext('CANCELED'),
    live: gettext('LIVE'),
    started: gettext('STARTED'),
    ended: gettext('ENDED'),
    completed: gettext('COMPLETED'),
    deleted: gettext('DELETED'),
};

export const EVENT_HEADER_SERIES_DROPDOWN_ID = 'event-header-series-dropdown';

// Google analytics for manage navigation
export const ACTION_NAV_LINK_CLICK = 'LeftNavLinkClick';
export const ACTION_NAV_MENU_TOGGLE = 'LeftNavMenuToggle';
export const ACTION_NAV_PAYMENT_OPTIONS = 'Nav2PaymentOptions';
export const ACTION_NAV_CHECKOUT_SETTINGS = 'Nav2CountryCurrency';
export const ACTION_NAV_TAX_OPTIONS = 'Nav2Tax';
export const ACTION_NAV_SHIPPING_SETTINGS = 'Nav2ShippingSettings';
export const ACTION_NAV_DESIGN = 'Nav1Design';
export const ACTION_NAV_PUBLISH_VIEW = 'Nav1PublishView';
export const ACTION_NAV_BASIC_INFO = 'Nav1Basics';
export const ACTION_NAV_DISPLAY = 'Nav2Display';
export const ACTION_NAV_PRIVACY = 'Nav2Privacy';
export const ACTION_HELP_ARTICLE = 'HelpArticle';
export const ACTION_GLOBAL_HEADER_NAV_LINK_CLICK = 'GlobalHeaderNavClick';
export const CATEGORY_MANAGE = 'manage';
export const LABEL_HELP_CENTER = 'HelpCenter';
